<template>
  <div ref="videoChatPage">
    <div class="vx-row">
      <div class="vx-col sm:w-full md:w-1/2 lg:w-2/3 xl:w-1/3 mx-auto">
        <vx-card id="video-chat-info-card">
          <div class="vx-row" v-if="Object.keys(videoChat).length > 0 && displayDate">
            <div class="vx-col">
              <div style="text-align: left;">
                <p class="text__school-font-color" style="font-size:18pt;font-variant: all-petite-caps;line-height: 1.5;"><strong>{{ currentDay == displayDate.split(" ")[0] ? 'Today' : displayDate.split(" ")[0] }}</strong></p>
                <p class="text__school-font-color" style="font-size:40pt;line-height: 40px;"><strong>{{ displayDate.split(" ")[1] }}</strong></p>
                <p class="text__school-font-color" style="font-size:25pt;font-variant: all-petite-caps;line-height: 1;">{{ displayDate.split(" ")[2] + ' ' + displayDate.split(" ")[3] }}</p>
                <p style="font-size:12pt;line-height: 2;"><strong>{{ videoChat.startTime + " - " + videoChat.endTime }}</strong></p>
              </div>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col sm:w-full md:w-1/2 lg:w-2/3 xl:w-2/3">
              <div class="vx-row mt-2">
                <div class="vx-col">
                  <p class="text__school-font-color" style="font-size:26pt;line-height: 1;"><strong>{{ videoChat.title }}</strong></p>
                </div>
              </div>
              <div class="vx-row mt-2">
                <div class="vx-col w-full">
                  <p class="text-white" style="text-align: justify;font-size:12pt;">{{ videoChat.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col mx-auto mt-5">
              <vs-button
                :disabled="!sessionInProgress"
                ref="search"
                class="custom-button_library mt-2 vs-con-loading__container school-primary_gradient"
                :class="[{ 'animate__flash-shadow': sessionInProgress }]"
                style="width:170px"
                @click="goToMeet">
                <img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:25px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-login-hover.png"/>
                <strong>Join</strong>
              </vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col mx-auto mt-5">
              <p style="font-size:10pt;line-height: 1;"><strong>{{ sessionStatus }}</strong></p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div v-show="!onlyContent" class="fab_direction-up__three-items">
      <div class="float-btn-group">
        <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
          <i class="icon feather icon-more-horizontal text-white" />
        </button>
        <div class="btn-list">
          <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
            <span class="descriptiontext">{{ topicName }}</span>
            <i class="icon feather icon-arrow-up text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
            <span class="descriptiontext">NEXT</span>
            <i class="icon feather icon-arrow-right text-white" />
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
            <span class="descriptiontext">PREVIOUS</span>
            <i class="icon feather icon-arrow-left text-white" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid';
import moment from 'moment'
export default {
  components: {
    moment
  },
  data() {
    return {
      queue: [],
      uuid: "",
      logData: {},
      fabElement: null,
      videoChat: {},
      fileExt: "",
      source: [],
      onlyContent : false,
      standaloneContentDto: {},
      selectedData: {},
      topicName: '',
      index: null,
      currentTask: null,
      nextTask: null,
      prevTask: null,
      navigateByChoice: false,
      isTeacher: false,
      currentDay: null,
      currentFullDate: null,
      displayDate: null,
      sessionStatus: "",
      sessionInProgress: false,
      refreshInterval: null,
      isUserPremium: false,
      onSuccessForUserCheck: false,
      startCourseTaskLog: false,
    };
  },
  methods: {
    setDisplayDate() {
      var self = this;

      if(self.videoChat.date) {
        var dateObj = new Date(Date.parse(self.videoChat.date));

        var result = moment(dateObj.toISOString()).format("dddd DD MMMM YYYY");

        self.currentDay = moment(new Date()).format("dddd");

        var newStartFullDateObj = new Date(dateObj.setHours(parseInt(self.videoChat.startTime.split(':')[0]), parseInt(self.videoChat.startTime.split(':')[1])));
        var newEndFullDateObj = new Date(dateObj.setHours(parseInt(self.videoChat.endTime.split(':')[0]), parseInt(self.videoChat.endTime.split(':')[1])));

        self.currentFullDate = new Date();

        self.sessionStatus = (self.currentFullDate < newStartFullDateObj) ? "Session not yet started..." : (self.currentFullDate > newEndFullDateObj) ? "Session ended." : "Session in progress...";
        self.sessionInProgress = (self.currentFullDate > newStartFullDateObj && self.currentFullDate < newEndFullDateObj);
        
        self.displayDate = result;
      }
    },
    goToMeet() {
      window.open(this.videoChat.url);
    },
    backToTopic() {
      var self = this;
      self.navigateByChoice = false;
      if(self.selectedData.selectedTopic)
        self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
      else if(self.selectedData.selectedTopic && self.isTeacher)
        self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
      else
        self.$router.push({ name: 'StudentRoster' });
    },
    next() {
      var self = this;
      self.index += 1;

      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));

      if(self.nextTask) {
        self.closeActions();

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.nextTask.id;
        self.enqueue("VideoChatTask/EndLogEntry", self.logData);

        self.currentTask = self.nextTask;
        
        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
        self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

        self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

        if(self.currentTask.videoChat && self.currentTask.videoChat.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.videoChat = self.currentTask.videoChat;

            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.videoChat = self.currentTask.videoChat;

            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if(self.currentTask.document && self.currentTask.document.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "DocumentViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if(self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.prevTask ? self.prevTask.id : null)
              }
            });
          }
      }
    },
    previous() {
      var self = this;
      self.index = --self.index;
      
      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));
      
      if(self.prevTask) {
        self.closeActions();

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.prevTask.id;
        self.enqueue("VideoChatTask/EndLogEntry", self.logData);

        self.currentTask = self.prevTask;

        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
        self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

        self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

        if(self.currentTask.videoChat && self.currentTask.videoChat.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.videoChat = self.currentTask.videoChat;
            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.videoChat = self.currentTask.videoChat;
            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if(self.currentTask.document && self.currentTask.document.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "DocumentViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
            self.navigateByChoice = true;
            self.$router.push({
              name: "UploadViewer",
              params: {
                index: self.index,
                standaloneContent: self.standaloneContentDto,
                selectedData: self.selectedData,
                fromTaskId: (self.nextTask ? self.nextTask.id : null)
              }
            });
            }
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
          successFunc();
        });
      }
    },
    getIsUserPremium(onComplete){
      var self = this;
      var onSuccess = function(response){
        if(response.data){
          self.activeSubscription = response.data != null ? response.data : 0;
          self.isUserPremium = response.data.isUserPremium;
        }
        onComplete();
      }
      self.$ajaxGet(self, "public/getactivesubscription" , onSuccess);
    },
    showPremiumContentPopup() {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Subscribe',
        html: `This is a premium task. <br> To access this content you have to be a <strong>premium subscriber</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          window.open("/subscriptions");
        }
        else{
          self.backToTopic();
        }
      });
    },
  },
  beforeDestroy() {
    var self = this;
    if(self.startCourseTaskLog){
      if(!self.navigateByChoice) {
        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.taskId = self.currentTask.id;
        self.logData.toTaskId = null;
        self.enqueue("VideoChatTask/EndLogEntry", self.logData);
      }
      clearInterval(self.refreshInterval);
    }
    
  },
  mounted() {
    var onComplete = response => {
      var self = this;
      self.$store.dispatch("updateTheme", "dark");
      self.startProcessor();

      self.isTeacher = localStorage.getItem("isTeacher");
      self.isTeacher = self.isTeacher == "true" ? true : false;

      var isStudentLocal = localStorage.getItem("isStudent");
      isStudentLocal = isStudentLocal == "true" ? true : false;

      if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
        if(self.$route.query.id){
          if(!localStorage.getItem("userInfo")) {
            document.cookie = "autoRedirect="+ JSON.stringify({url: "VideoChatPage", id: self.$route.query.id});
            window.location.replace("/login");
          }

            var success = (res) => {
              self.onlyContent = true;
              self.videoChat = res.data;
              self.uuid = self.$uuid.v4();

              self.logData.taskId = self.$route.query.id;
              localStorage.setItem("tid", self.$route.query.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;

              self.setDisplayDate();
              if (!self.refreshInterval) {
                self.refreshInterval = setInterval(function() {
                  self.setDisplayDate();
                }, 5000);
              }
            };

          try{
            self.$ajaxGet(self, "VideoChatTask/GetVideoChat/" + self.$route.query.id, success);
          } catch{} 
        }
      }
      else {
        if(Object.keys(this.$route.params).length != 0){
          self.index = self.$route.params.index;

          self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

          self.videoChat = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].videoChat;

          self.setDisplayDate();
          if (!self.refreshInterval) {
            self.refreshInterval = setInterval(function() {
              self.setDisplayDate();
            }, 5000);
          }

          if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
            self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

          if (self.index > 0)
            self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

          self.standaloneContentDto = self.$route.params.standaloneContent;
          if(self.$route.params.selectedData)
            self.selectedData = self.$route.params.selectedData;

          var data = {
            selectedData: self.selectedData,
            standaloneContentDto: self.standaloneContentDto,
            index: self.index
          }

          localStorage.setItem("lastKnownTopic", JSON.stringify(data));

          if(self.selectedData.selectedTopic)
            self.topicName = self.selectedData.selectedTopic.name;
          else
            self.topicName = "Back to My Roster";
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.uuid = self.$uuid.v4();
            self.logData.taskId = self.currentTask.id;
            localStorage.setItem("tid", self.currentTask.id);
            self.logData.logIdentifier = self.uuid;
            self.logData.toTaskId = null;
            self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent")){
            self.uuid = self.$uuid.v4();
            self.logData.taskId = self.currentTask.id;
            localStorage.setItem("tid", self.currentTask.id);
            self.logData.logIdentifier = self.uuid;
            self.logData.toTaskId = null;
            self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
            self.enqueue("VideoChatTask/StartLogEntry", self.logData);
          }
          else{
            self.showPremiumContentPopup();
          }
        }
        else {
          if (isStudentLocal) {
            self.$router.push({ name: 'StudentRoster' });
          }
          else {
            self.$router.push({ name: 'BrowseContent' });
          }
        }
      }
    }
    this.getIsUserPremium(onComplete);
  }
};
</script>

<style lang="scss">
  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 70px;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }

  #video-chat-info-card {
    &.vx-card {
      border-radius: 2.2rem !important;
    }
  }

  .animate__flash-shadow {
    animation: blinker 1.3s linear infinite;
    box-shadow: 0 0 9px 2px rgba(var(--vs-tertiary),1);
  }

  @keyframes blinker {
    50% {
      box-shadow: 0 0 4px 2px rgba(var(--vs-tertiary),0.4);
    }
  }
</style>
